module.exports = __webpack_public_path__ + "img/share-blue.393595a2.svg";